<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="file-person"></b-icon>
              Mein Profil
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- Neue Vergabeeinheit -->
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      <div class="row mt-1">
        <div class="col-8">
          <b-button @click="saveRecord" class="mr-2">
            <b-icon icon="check-2" />
            Speichern
          </b-button>
          <b-button @click="sendPwResetMail" variant="outline-secondary">
            <b-icon icon="key" class="mr-1" />
            Kennwort zurücksetzen
          </b-button>
        </div>
      </div>

      <div class="row mt-3" style="max-width:960px">
        <div class="col-8">
          <div class="row mt-1">
            <div class="col-12">
              <label class="text-muted">
                <small>Anzeigename</small>
              </label>

              <b-input disabled v-model="$root.$user.name" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <label class="text-muted">
                <small>E-Mail Adresse (Anmeldename)</small>
                <b-icon
                  style="vertical-align: -0.15em; margin-left: 3px"
                  icon="info-circle"
                  title="Ihre E-Mail Adresse lässt sich nicht ändern. Lassen Sie sich gegebenfalls mit einer neuen Emailadresse von dem Projektadmin neu einladen"
                  class="text-muted"
                ></b-icon>
              </label>
              <b-input disabled v-model="$root.$user.email" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <label>Projekte</label>
              <ul>
                <li v-for="project of ProjectStore.projects" :key="project.DbId">
                  <span class="text-muted small">{{ project.ProjectIdentifier }}</span>
                  &nbsp;{{ project.Name }}&nbsp;
                  <span class="text-muted small">
                    <small>({{ calcAccessLevel(project) }})</small>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-4 bg-white border p-4 text-center " style="height:180px;margin-top:10px;">
          <input class="d-none" type="file" @change="onPicturePicked($event)" ref="fileInput" />
          <!-- <img :src="pictureData" class="uploadImage" @click="openFileDialog" /> -->
          <b-avatar button @click="openFileDialog" variant="info" :src="pictureData" size="6em"></b-avatar>
          <br />
          <div class="pt-3"><small>Klicken, um Foto auszuwählen</small></div>
        </div>
      </div>
      <!--
      <li>Persönliches Profilfoto</li>
      <li>Kundenzuordnung</li>
      <li>Berechtigte Projekte mit Rolle</li>-->

      <!-- <pre class="mt-5">{{ $root.$user }}</pre> -->
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import UsersService from '@/service/UserService';
import ProjectStore from '@/store/Projects';
export default {
  activated() {
    AppState.isLoading = false;
    UsersService.getUserPicture().then(image => (this.pictureData = Buffer.from(image).toString()));
  },
  data() {
    return {
      pictureData: null,
      ProjectStore
    };
  },
  methods: {
    onPicturePicked(e) {
      //console.log('zzz e', e.target.files[0]);
      const reader = new FileReader();

      reader.onload = event => {
        this.pictureData = event.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    sendPwResetMail() {
      UsersService.sendPwResetMail().then(() => {
        this.$bvModal.msgBoxOk(
          'Eine Mail mit einem Link zum Zurücksetzen des Kennworts wurde an ' + this.$root.$user.email + ' gesendet.',
          {
            title: 'Kennwort zurücksetzen',
            centered: true
          }
        );
      });
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    saveRecord() {
      UsersService.setUserPicture(this.pictureData).then(() => {
        this.$root.$user.picture = Buffer.from(this.pictureData).toString();
        this.$showSuccess(this, 'Mein Profil', 'Profil erfolgreich gespeichert.');
      });
    },
    calcAccessLevel(project) {
      if (project.IsSuperAdmin == 'true') return 'Superadmin';
      if (project.IsAdmin == 'true') return 'Projektadmin';
      if (project.IsPlaner == 'true') return 'Assistenz';
      return 'Leser';
    }
  }
};
</script>

<style scoped>
.uploadImage {
  max-height: 200px;

  max-width: 200px;

  object-fit: cover;
  border: 1px solid #dee2e6;
}
</style>
